import React from 'react';

export default function TitleAttrSingle({ className = '', children }) {
    return <h2 className={`default-color-title custom-style-h2 ${className}`}>{children}</h2>;
}
